import React from "react";
import Slider from "react-slick";

const TestimonialSectionabout = () => {

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

 const testimonials = [
  {
    name: "Mr. Arjun Sharma",
    // image: "/images/testimonial/pic1.jpg",
    role: "Software Engineer",
    review: "Velocity Cab made my Pune to Mumbai trip stress-free! The cab was clean, and the driver was very polite."
  },
  {
    name: "Miss. Priya Singh",
    role: "Doctor",
    review: "I loved their prompt pickup service. The ride was comfortable and timely. Highly recommended!"
  },
  {
    name: "Mr. Rohan Mehta",
    image: "/images/testimonial/pic3.jpg",
    role: "Business Owner",
    review: "Affordable rates with premium service. Velocity Cab ensured I reached my destination safely and on time."
  },
  {
    name: "Miss. Ananya Patel",
    role: "Teacher",
    review: "The driver was courteous and professional. Booking through Velocity Cab was very easy and convenient."
  },
  {
    name: "Mr. Vikram Rao",
    image: "/images/testimonial/pic5.jpg",
    role: "Chartered Accountant",
    review: "I appreciate the clean vehicles and smooth ride. Velocity Cab is my go-to choice for intercity travel."
  },
  {
    name: "Miss. Sneha Kapoor",
    role: "Marketing Manager",
    review: "Excellent service! The cab arrived on time, and the journey was safe and comfortable. Will book again."
  }
];

  return (
    <div className="section-full py-5 site-bg-dark twm-testimonial-section-wrap">
      <div className="container">

        {/* Title */}
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left">Testimonials</div>
              <h2 className="twm-large-title site-text-white text text-white">
                What Our Customers Say About Velocity Cab
              </h2>
            </div>
          </div>
        </div>

        <div className="section-content">
          <Slider {...settings} className="twm-blog-carousel next-prev-top-right">
            {testimonials.map((item, index) => (
              <div className="item" key={index}>
                <div className="twm-testimonial2 drk-view">

                  <div className="twm-testimonial-head">
                    <div className="media-pic">
                      <img src={item.image} alt={item.name} />
                    </div>
                    <div className="twm-author-detail">
                      <h3 className="twm-title">{item.name}</h3>
                    <div className="twm-position">{item.role}</div>
                    </div>
                  </div>

                  <div className="twm-testimonial-detail">
                    <p>{item.review}</p>
                    <div className="twm-rating-wrap">
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                    </div>
                  </div>

                  <div className="twm-quote-icon">
                    <img src="/images/quote.png" alt="quote" />
                  </div>

                </div>
              </div>
            ))}
          </Slider>
        </div>

      </div>
    </div>
  );
};

export default TestimonialSectionabout;